import { FeatureFlagIds } from "../../../utils/featureFlagIds";
import { isFinicityEnabled } from "../../../utils/finicityUtils";
import React, { CSSProperties, useEffect, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { AppBar, createStyles, IconButton, Tab, Tabs } from "@mui/material";
import TabPanel from "../../TabPanel";
import VehicleSelect from "./VehicleSelect";
import BureauPage from "./BureauPage";
import CustomFieldForm from "./CustomFieldForm";
import { AppState } from '../../../store/rootReducer';
import { IApplication } from "../../../Interfaces/Application/IApplication";
import {
  addVehicleToApplication,
  getApplicationChats,
  getDealerTrackApplicationHistory,
  saveApp,
  updateEditingApp
} from "../../../store/application/actions";
import {
  ApplicationDispatch,
  CREATE_APPLICATION_SUCCESS,
  getDownPaymentHistories,
  getPreviousAmsLoans
} from "../../../store/application/types";
import { BusinessAction, BusinessRulesEngine, useBusinessRulesEngine, } from "../../../Data/BusinessRulesData";
import { showValidationDialog } from "../../../utils/ValidationDialog";
import { Overview } from "./Overview/Overview";
import { BudgetPage } from "../BudgetPage";
import { ApplicationDocuments } from "../../ApplicationDocuments";
import { ApplicantInfo } from "./ApplicantInfo";
import {
  allApplicationChecklistsAreComplete,
  canViewAnyAvailableChecklist,
  getApplicant,
  hideChatBar,
  isInRole,
  updateApplicationCustomFields
} from "../../../utils/appUtils";
import Tooltip from "@mui/material/Tooltip";
import LockNotice from "../../Shared/LockNotice";
import {
  Document,
  useApplicationDocuments,
  useApplicationFinicityDocuments
} from "../../../Data/ApplicationDocumentData";
import { TextMessageChat } from "../TextMessageChat";
import { getSelectedFinanceQuote, isIndirectConvertedToFinance, usesFundingModule } from "../../../utils/quoteUtils";
import { getFirstPaymentReview } from "../../../utils/firstPaymentReview";
import { useLeaseQuoteRefusal } from "../../../hooks/UseLeaseQuoteRefusal";
import { Constants, INCOMPLETE_INSURANCE_MESSAGE, permissions } from "../../../utils/constants";
import { useConfiguration } from '../../../Data/ConfigurationData';
import ApplicationNotes from './ApplicationNotes';
import UnderwriterNotes from './UnderwriterNotes';
import NotePopup from '../../NotePopup';
import { v4 } from 'uuid';
import { addApplicationNotes, addApplicationUnderwriterNotes } from '../../../Data/ApplicationData';
import { userHasPermission } from '../../../utils/utils';
import ApplicationChecklistSideBar, { ChecklistButtonToolTipText } from "../ApplicationChecklistViewer";
import CheckIcon from "@mui/icons-material/Check";
import { useDrawer } from "../../../providers/DrawerProvider";
import { MS_PER_MINUTE } from "@progress/kendo-date-math";
import styles from './_order-editor-tabs.module.scss';
import { getApplicationRehashes } from "../../../Data/ApplicationRehashData";
import { ICustomValuePair } from "../../../Interfaces/Application/ICustomValuePair";
import { IAppCustomer } from "../../../Interfaces/Application/IAppCustomer";
import { useEmployeeRolePermissions } from "../../../Data/EmployeeRoleData";
import JdPowersportHistory from "./JdPowersportHistory";
import EmailNotifications from "./EmailNotifications";
import { OverviewCustomizable } from "./OverviewCustomizable/OverviewCustomizable";
import {ApplicationQuoteType, hasValue, PermissionSet, Vehicle} from "@amsanalytics/react-shared-library";
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from "react-router";
import { useDialog } from "../../../providers/DialogProvider";
import { usePostedAppLock } from "../../../hooks/usePostedAppLock";
import FirstPaymentAndExtraPaymentDialog
  from "../../Dialogs/FirstPaymentAndExtraPaymentDialog/FirstPaymentAndExtraPaymentDialog";
import ConfirmationDialog from "../../Dialogs/ConfirmationDialog";
import produce from "immer";
import { ConfirmHardPullRequirement } from "../../Dialogs/ConfirmHardPullRequirement";
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button as KendoButton } from '@progress/kendo-react-buttons';
import { validateInsuranceForPostingAsync } from './StatusWorkflowComponent';
import NotesDialog from "./NotesDialog";
import { IEmployee } from "../../../Interfaces/Admin/IEmployee";
import IncomeVerificationPage from "./IncomeVerificationPage";
import RuleOverrideEditor from "../../RuleOverrideEditor/RuleOverrideEditor";
import FundingPage from "./FundingPage/FundingPage";
import { getAppQuoteByType } from "../../Quoters/IndirectQuoter/IndirectQuoterUtils";
import { IndirectQuoteType } from "../../../Data/IndirectQuoteType";
import { shouldLoadDealerServiceHistory } from "../../../utils/dealerServiceHistoryUtils";
import IndirectStipsEditor from "../../IndirectStipsEditor/IndirectStipsEditor";

interface OrderEditorTabsProps {
}

export const handleVehicleUpdate = (
  currentApp: IApplication,
  vehicle: Vehicle,
  useVehicleWhenVehicleChanges: boolean,
  dispatch: ApplicationDispatch,
  businessRulesEngine: BusinessRulesEngine
): void => {
  dispatch(addVehicleToApplication(currentApp, vehicle, businessRulesEngine, useVehicleWhenVehicleChanges));
};

const OrderEditorTabs: React.FC<OrderEditorTabsProps> = (props) => {
  const { data: configuration } = useConfiguration();
  const [value, setValue] = useState<number>(0);
  const [applicationId, setApplicationId] = useState<string | undefined>(undefined);
  const navigate = useNavigate();
  const currentApp: IApplication = useSelector((state: AppState) => state.applications.editingApp!);
  // const payTypes: IQuotePayType[] = useSelector((state: AppState) => state.applications.quotePayTypes);
  // const activeUser: IEmployee = useSelector((state: AppState) => state.applications.loggedInUser!.employee);
  const currentUser = useSelector((state: AppState) => state.applications.loggedInUser?.employee);
  const primary = currentApp && getApplicant(currentApp, Constants.roleApplicantId, true);
  const cobuyer1 = currentApp && getApplicant(currentApp, Constants.roleCoApplicant1Id, true);
  const cobuyer2 = currentApp && getApplicant(currentApp, Constants.roleCoApplicant2Id, true);
  const isNewApplication =
    currentApp && currentApp.id === Constants.newApplicationId;
  const dispatch = useDispatch();
  const businessRulesEngine = useBusinessRulesEngine();
  const [showNotesPopup, setShowNotesPopup] = useState<boolean>(false);
  const [showUnderwriterNotesPopup, setShowUnderwriterNotesPopup] = useState<boolean>(false);
  const newlyCreatedApplicationId: string | undefined = useSelector(
    (state: AppState) => state.applications.newApplicationId
  );
  const lookups = useSelector((state: AppState) => state.applications.lookups);
  const [isChecklistOpen, setIsChecklistOpen] = useState<boolean>(false);
  const [isHoveringOverCheck, setIsHoveringOverCheck] = useState<boolean>(false);
  const [rightSideBarWidth, setRightSideBarWidth] = useState<number>(0);
  const [nestedTabNameFlag, setNestedTabNameFlag] = useState<string | undefined>(undefined);
  const [openDrawer, closeDrawer] = useDrawer();
  const [canView, canEdit, canAct, canActInStatus] = useEmployeeRolePermissions();
  const { isSectionLocked, lockedTooltip, lockMessage } = usePostedAppLock();
  const userCanViewJdPowersportHistory = userHasPermission(currentUser!, permissions.losJdPowersportHistoryTab, PermissionSet.R);
  const userCanViewVehicleTab = userHasPermission(currentUser!, permissions.losVehicleTab, PermissionSet.R);
  const userCanViewCustomFieldsTab = userHasPermission(currentUser!, permissions.losCustomFieldsTab, PermissionSet.R);
  const userCanViewBudgetTab = userHasPermission(currentUser!, permissions.losBudgetTab, PermissionSet.R);
  const userCanViewStipsTab = userHasPermission(currentUser!, permissions.losStipsTab, PermissionSet.R);
  const userCanViewBureauTab = userHasPermission(currentUser!, permissions.losBureauTab, PermissionSet.R);
  const userCanViewNotesTab = userHasPermission(currentUser!, permissions.losNotesTab, PermissionSet.R);
  const userCanViewUnderwriterNotesTab = userHasPermission(currentUser!, permissions.losUnderwriterNotesTab, PermissionSet.R);
  const userCanViewNotificationsTab = userHasPermission(currentUser!, permissions.losNotificationsTab, PermissionSet.R);
  // Finicity is licensed per client (FinicityEnabled flag); the permission alone must not show the tab or start polling.
  const userCanViewIncomeVerificationTab = isFinicityEnabled(configuration) && userHasPermission(currentUser!, permissions.finicityBankVerification, PermissionSet.R);
  const clientPostsLoansDirectlyToAms = configuration?.featureFlags[FeatureFlagIds.ClientPostsLoansDirectlyToAms] === true;
  // const dealertrackDealerDecisionData = useSelector((state: AppState) => state.applications.dealertrackDealerDecisionData);
  const underWriterQuote = getAppQuoteByType(currentApp, IndirectQuoteType.Underwriter);
  // To show the Funding Module:
  // 1. The indirect quote must have a pay type to show the funding tab. Otherwise, we cannot compute a payment schedule.
  // 2. The application must be in "Contract Received" status or later
  // 3. The indirect deal must post from the underwriter quote. One that was moved forward to a finance quote (a client
  //    that prints its own indirect documents) posts from that instead and has no funding module.
  const showFundingTab = clientPostsLoansDirectlyToAms && usesFundingModule(currentApp, configuration) && underWriterQuote && underWriterQuote.quote.quotePayTypeId &&
    (currentApp?.appStatusId?.toLowerCase() === Constants.applicationStatuses.finalizedPosted.toLowerCase()
      || currentApp?.appStatusId?.toLowerCase() === Constants.applicationStatuses.readyToBook.toLowerCase()
      || currentApp?.appStatusId?.toLowerCase() === Constants.applicationStatuses.verificationIncomplete.toLowerCase()
      || currentApp?.appStatusId?.toLowerCase() === Constants.applicationStatuses.contractReceived.toLowerCase()
    );
  const defaultRightSideBarWidth = 500;
  const selectedFinanceQuote = getSelectedFinanceQuote(currentApp);
  const showRefusalFor = useLeaseQuoteRefusal();
  const store = useStore<AppState>();
  const [openDialog, closeDialog] = useDialog();

  const handleAddNotes = (notes: { note: string, isDecisionNote: boolean, createdDate: Date }[], bypassAppRequirements?: boolean): void => {
    const result = businessRulesEngine({
      action: "Notes",
    });
    if (result?.errors?.length && !bypassAppRequirements) {
      showValidationDialog({
        errors: result.errors,
        callback: () => handleAddNotes(notes, true),
      });
    } else {
      addApplicationNotes(currentApp!.id, notes, dispatch);
      setShowNotesPopup(false);
    }
  };

  // Navigate to the order when a new order is created
  useEffect(() => {
    if (newlyCreatedApplicationId !== null && newlyCreatedApplicationId !== undefined) {
      dispatch({
        type: CREATE_APPLICATION_SUCCESS,
        payload: { applicationId: undefined },
      });
      navigate(`/order/${newlyCreatedApplicationId}/true`);
    }
  }, [newlyCreatedApplicationId]);
  
  const aDifferentApplicationLoaded = currentApp && currentApp.id !== applicationId;

  // Gets new data when the application changes
  useEffect(() => {
    if (aDifferentApplicationLoaded) {
      if (configuration?.featureFlags?.[FeatureFlagIds.ApplicationRehashes]) {
        dispatch(getApplicationRehashes(currentApp.id));
      }
      if (configuration?.featureFlags?.[FeatureFlagIds.UseLOSChat]) {
        dispatch(getApplicationChats(currentApp.id));
      }
      
      dispatch(getPreviousAmsLoans(currentApp.id));
    }
  }, [currentApp]);
  
  const getDownPaymentResponses = () => {
    // A moved-forward indirect deal is contracted from the finance quote, so its posting checks need the collected
    // down payments like a direct Finance deal.
    if (configuration?.featureFlags[FeatureFlagIds.TakeDownPayments]
      && (currentApp.quoteType !== ApplicationQuoteType.Indirect || isIndirectConvertedToFinance(currentApp, configuration))) {
      dispatch(getDownPaymentHistories(currentApp.id));
    }
  }

  useEffect(() => {
    if (aDifferentApplicationLoaded) {
      // Once when it loads
      getDownPaymentResponses();

      // Repeats every X minutes
      let timer = setInterval(async () => {
        getDownPaymentResponses();
      }, 2 * MS_PER_MINUTE); // 2 Minutes
      return () => clearInterval(timer);
    }
  }, [currentApp]);

  useEffect(() => {
    if (currentApp && currentApp.id !== applicationId) {
      if (shouldLoadDealerServiceHistory(currentApp)) {
        // Removed call to get dealertrackDealerDecisionData.
        // This is now in a quote object in editingApp.ApplicationQuotes where quoteType === IndirectQuoteType.DealerRequested (i.e. 3)
        dispatch(getDealerTrackApplicationHistory(currentApp.id));
      }
    }
  }, [currentApp, businessRulesEngine]);

  useEffect(() => {
    if (currentApp && applicationId !== currentApp.id) {
      setApplicationId(currentApp.id);
    }
  }, [currentApp]);

  useEffect(() => {
    if (shouldLoadDealerServiceHistory(currentApp)) {
      let interval: number = -1;
      interval = window.setInterval(() => {
        if (hasValue(applicationId)) {
          dispatch(getDealerTrackApplicationHistory(currentApp.id));
        }
      }, 5 * MS_PER_MINUTE); //5 minutes
      return () => {
        clearInterval(interval);
      }
    }
  }, [applicationId]);
  useEffect(() => {
    let interval: number = -1;
    interval = window.setInterval(() => {
      if (hasValue(applicationId)) {
        if (configuration?.featureFlags?.[FeatureFlagIds.UseLOSChat]) {
          dispatch(getApplicationChats(currentApp.id));
        }
      }
    }, 0.5 * MS_PER_MINUTE); // 30 seconds
    return () => {
      clearInterval(interval);
    }
  }, [applicationId]);
  useEffect(() => {
    let interval: number = -1;
    interval = window.setInterval(() => {
      if (hasValue(applicationId)) {
        if (configuration?.featureFlags?.[FeatureFlagIds.ApplicationRehashes]) {
          dispatch(getApplicationRehashes(currentApp.id));
        }
      }
    }, 0.25 * MS_PER_MINUTE); // 15 seconds
    return () => {
      clearInterval(interval);
    }
  }, [applicationId]);

  const tabsVisible: TabName[] = [];
  tabsVisible.push("Overview");
  if (primary) {
    tabsVisible.push("Applicant");
  }
  if (cobuyer1 && cobuyer1.deleted !== true) {
    tabsVisible.push("Co-Applicant 1");
  }
  if (cobuyer2 && cobuyer2.deleted !== true) {
    tabsVisible.push("Co-Applicant 2");
  }
  if (userCanViewBureauTab && !(configuration?.featureFlags?.[FeatureFlagIds.HideBureauTab] === true && (isInRole(Constants.roles.salespersonId, currentUser)))) {
    tabsVisible.push("Bureau");
  }
  if (userCanViewVehicleTab) {
    tabsVisible.push("Vehicle");
  }
  if (configuration?.featureFlags?.[FeatureFlagIds.CanViewCustomFieldsTab] === true && userCanViewCustomFieldsTab) {
    tabsVisible.push("Custom Fields");
  }
  if (userCanViewBudgetTab) {
    tabsVisible.push("Budget");
  }

  tabsVisible.push("Documents");

  if (userCanViewStipsTab) {
    tabsVisible.push("Stips");
  }

  if (userCanViewNotesTab) {
    tabsVisible.push("Notes");
  }

  if (userCanViewUnderwriterNotesTab) {
    tabsVisible.push("Underwriter Notes");
  }

  if (showFundingTab) {
    tabsVisible.push("Funding");
  }
  if (userCanViewJdPowersportHistory) {
    tabsVisible.push("JD Powersport History");
  }
  if (userCanViewNotificationsTab) {
    tabsVisible.push("Notifications");
  }
  if (configuration?.featureFlags?.[FeatureFlagIds.OverrideBusinessRules] === true) {
    tabsVisible.push("Validation Rules");
  }
  if (userCanViewIncomeVerificationTab) {
    tabsVisible.push("Income Verification");
  }

  const getTabIndex = (tabName: TabName) => {
    const i = tabsVisible.findIndex((tab) => tab === tabName);
    return i;
  };
  const tabItemStyle: CSSProperties = {
    display: 'flex', flex: 1, flexDirection: 'column',
    height: 'calc(100vh - 112px)', overflowY: 'auto', overflowX: 'hidden',
    paddingBottom: '50px'
  };
  const handleChange = (
    _event: any,
    newValue: number,
    bypassAppRequirements?: boolean
  ): void => {
    const tabName = tabsVisible[newValue];
    const action = tabNameToAction[tabName];
    const result = action ? businessRulesEngine({ action }) : { errors: [] };
    if (result?.errors?.length && !bypassAppRequirements) {
      showValidationDialog({
        errors: result.errors,
        callback: () => handleChange(_event, newValue, true),
      });
    } else {
      setValue(newValue);
    }
  };
  const handleCustomFieldUpdate = (field: ICustomValuePair): void => {
    if (currentApp) {
      updateApplicationCustomFields([{ formattedValue: field.formattedValue, customFieldName: field.customFieldName, valueType: field.valueType }], currentApp, dispatch, businessRulesEngine);
    }
  };
  const addNote = (): void => {
    setShowNotesPopup(true);
  };

  const addUnderwriterNote = (): void => {
    setShowUnderwriterNotesPopup(true);
  };

  let applicationDocumentsFromServer: Document[] | undefined;
  applicationDocumentsFromServer = useApplicationDocuments(dispatch, currentApp?.id);

  let applicationFinicityDocumentsFromServer: Document[] | undefined;
  applicationFinicityDocumentsFromServer = useApplicationFinicityDocuments(dispatch, currentApp?.id, userCanViewIncomeVerificationTab);

  // Closes the checklist drawer if the page is navigated away from
  useEffect(() => {
    return () => {
      closeDrawer();
    }
  }, []);

  const canNotEditBudget = (configuration?.featureFlags?.[FeatureFlagIds.PreventSalesFromEditingBudget] === true)
    && (isInRole(Constants.roles.salespersonId, currentUser)
      || isInRole(Constants.roles.salesManagerId, currentUser)
      || isInRole(Constants.roles.regionalManagerId, currentUser));


  // Returns the tab component for the primary applicant
  const getPrimaryApplicantTab = () => {
    if (primary) {
      if (currentApp.areApplicationCustomersEditable) {
        return (
          <Tab label='Applicant' />
        );
      }
      return (
        <Tooltip title='Applicant details are not editable until all customers acknowledge this information' placement='bottom'>
          <Tab label='Applicant' icon={<ErrorIcon />} iconPosition="end" />
        </Tooltip>
      );
    }
  }

  // Returns the tab component for the co-applicant
  const getCoApplicantTab = (coApplicant: IAppCustomer | undefined, label: string) => {
    if (coApplicant && coApplicant.deleted !== true) {
      if (currentApp.areApplicationCustomersEditable) {
        return (
          <Tab label={label} />
        );
      }
      return (
        <Tooltip title='Co-Applicant details are not editable until all customers acknowledge this information' placement='bottom'>
          <Tab label={label} icon={<ErrorIcon />} iconPosition="end" />
        </Tooltip>
      );
    }
  }

  const saveApplication = async (bypassAppRequirements: boolean, userBypassedSoftPullRequirement: boolean) => {
    const result = businessRulesEngine({
      action: "Save",
    });
    if (result?.errors?.length && !bypassAppRequirements) {
      showValidationDialog({
        errors: result.errors,
        callback: () => saveApplication(true, userBypassedSoftPullRequirement),
      });
    } else {
      await dispatch(saveApp(businessRulesEngine, userBypassedSoftPullRequirement));
    }
  }

  const updateReDeskDealToAms = () => {
    const updatedApp = produce(currentApp!, appToUpdate => {
      appToUpdate.reDeskDealToAms = true;
    })
    dispatch(updateEditingApp(updatedApp, businessRulesEngine));
  }

  const handleSaveAppFromOverview = async (
    currentApp: IApplication,
    originalApplicationStatus: string,
    bypassAppRequirements: boolean
  ): Promise<void> => {
    const appStatusChanged = originalApplicationStatus.toLowerCase() !== currentApp.appStatusId.toLowerCase();
    const newStatusIsDeskingStatus = currentApp.appStatusId.toLowerCase() === Constants.applicationStatuses.desking.toLowerCase();
    const newStatusIsFinalizedAndPosted = currentApp.appStatusId.toLowerCase() === Constants.applicationStatuses.finalizedPosted.toLowerCase();

    // Validate required insurance fields when desking or posting
    if ((appStatusChanged && newStatusIsDeskingStatus) || newStatusIsFinalizedAndPosted || currentApp.reDeskDealToAms) {
      const hasIncompleteInsurance = await validateInsuranceForPostingAsync(currentApp.id);
      if (hasIncompleteInsurance) {
        openDialog({
          children: (
            <Window title="Incomplete Vehicle Insurance" onClose={closeDialog} width={500} height={250}>
              <p style={{ margin: '10px 0' }}>{INCOMPLETE_INSURANCE_MESSAGE}</p>
              <WindowActionsBar>
                <KendoButton themeColor="primary" onClick={closeDialog}>OK</KendoButton>
              </WindowActionsBar>
            </Window>
          ),
        });
        return;
      }
    }

    // Making sure the app status didn't change to Desking / Posted and also that it isn't a re-desking
    if (!(appStatusChanged && newStatusIsDeskingStatus) && !currentApp.reDeskDealToAms) {
      await saveApplication(bypassAppRequirements, false);
      return;
    }

    if (currentApp.quoteType === ApplicationQuoteType.Lease && showRefusalFor('desking')) {
      // The re-desk button turns the flag on before this check; a refused re-desk must not reach the next Save.
      const latestApp = store.getState().applications.editingApp;
      if (latestApp?.reDeskDealToAms) {
        dispatch(updateEditingApp({ ...latestApp, reDeskDealToAms: false }, businessRulesEngine));
      }
      return;
    }

    // Check to see if any of the applicants have only had a soft pull
    const userBypassedSoftPullRequirement = await ConfirmHardPullRequirement(currentApp, openDialog, closeDialog);
    if (userBypassedSoftPullRequirement === false) {
      return;
    }

    const reDeskPromptMessage = 'Are you sure you want to save the application and send the changes to AMS? MAKE SURE TO USE THIS APPLICATION WHEN POSTING THE LOAN AND DISREGARD ANY PREVIOUSLY DESKED APPLICATION IN AMS 2000.';

    const firstPaymentReview = getFirstPaymentReview(currentApp, selectedFinanceQuote);
    if (firstPaymentReview) {
      openDialog({
        children: (
          <FirstPaymentAndExtraPaymentDialog
            addOnMessage={currentApp.reDeskDealToAms
              ? reDeskPromptMessage
              : undefined}
            review={firstPaymentReview}
            accept={async () => { // save and calculate
              updateReDeskDealToAms();
              await saveApplication(bypassAppRequirements, userBypassedSoftPullRequirement ?? false);
              closeDialog();
            }}
            closeDialog={closeDialog} // cancel
          />
        )
      })
    } else {
      openDialog({
        children: (
          <ConfirmationDialog
            title={'Save and Re-desk?'}
            prompt={reDeskPromptMessage}
            accept={() => { // save and calculate
              updateReDeskDealToAms();
              saveApplication(bypassAppRequirements, userBypassedSoftPullRequirement ?? false);
              closeDialog();
            }}
            closeDialog={closeDialog} // cancel
          />
        )
      })
    }
  }

  return (
    <div
      className={styles.orderEditorContainer}
      style={{ marginRight: `${rightSideBarWidth}px` }}
    >
      <AppBar position='sticky' color='inherit' elevation={1}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor='primary'
          textColor='primary'
          variant='scrollable'
          scrollButtons='auto'
          aria-label='scrollable auto tabs'
        >
          {!isNewApplication &&
            <Tab label='Overview' />
          }
          {getPrimaryApplicantTab()}
          {getCoApplicantTab(cobuyer1, 'Co-Applicant 1')}
          {getCoApplicantTab(cobuyer2, 'Co-Applicant 2')}
          {userCanViewBureauTab && !(configuration?.featureFlags?.[FeatureFlagIds.HideBureauTab] === true && (isInRole(Constants.roles.salespersonId, currentUser))) &&
            <Tab
              // icon={<AccountBalance />}
              label='Bureau'
            />
          }
          {userCanViewVehicleTab &&
            <Tab
              // icon={<DirectionsCar />}
              label='Vehicle'
            />
          }
          {configuration?.featureFlags?.[FeatureFlagIds.CanViewCustomFieldsTab] === true && userCanViewCustomFieldsTab &&
            <Tab
              // icon={<List />}
              label='Custom Fields'
              style={{ color: canNotEditBudget ? 'red' : 'default' }}
            />
          }
          {userCanViewBudgetTab &&
            <Tab
              // icon={<GridOnIcon />}
              label='Budget'
            />
          }
          <Tab
            // icon={<PermMediaIcon />}
            label='Documents'
          />
          {userCanViewStipsTab &&
            <Tab
              // icon={<AssignmentTurnedInIcon />}
              label='Stips'
            />
          }
          {userCanViewNotesTab &&
            <Tab label='Notes' />
          }
          {userCanViewUnderwriterNotesTab && currentApp?.applicationNotes?.filter(an => !an.deleted && an.applicationNoteRoles?.length && an.applicationNoteRoles?.length > 0).length > 0 &&
            <Tab label='Underwriter Notes' style={{ color: 'red' }} />
          }
          {userCanViewUnderwriterNotesTab && currentApp?.applicationNotes?.filter(an => !an.deleted && an.applicationNoteRoles?.length && an.applicationNoteRoles?.length > 0).length === 0 &&
            <Tab label='Underwriter Notes' />
          }
          {showFundingTab &&
            <Tab
              label='Funding'
            />
          }
          {userCanViewJdPowersportHistory &&
            <Tab
              label='JD Powersport History'
            />
          }
          {userCanViewNotificationsTab &&
            <Tab label='Notifications' />
          }
          {
            configuration?.featureFlags?.[FeatureFlagIds.OverrideBusinessRules] === true && (
              <Tab label='Validation Rules' />
          )}
          {userCanViewIncomeVerificationTab && // (applicationFinicityDocumentsFromServer?.length ?? 0) > 0 &&
            <Tab label='Income Verification' />
          }
        </Tabs>
      </AppBar>
      {configuration?.featureFlags?.[FeatureFlagIds.UseCustomizableOverviewScreen] === true &&
        <TabPanel value={value} index={getTabIndex('Overview')}>
          {value === getTabIndex('Overview') && configuration &&
            <OverviewCustomizable
              configuration={configuration}
              navigate={(tabName: TabName) => {
                const i = getTabIndex(tabName);
                if (i >= 0) {
                  setValue(i);
                }
              }}
              setNestedTabNameFlag={setNestedTabNameFlag}
              handleSaveAppFromOverview={handleSaveAppFromOverview}
            />
          }
        </TabPanel>
      }
      {configuration?.featureFlags?.[FeatureFlagIds.UseCustomizableOverviewScreen] !== true &&
        <TabPanel value={value} index={getTabIndex('Overview')}>
          {value === getTabIndex('Overview') && configuration &&
            <Overview
              configuration={configuration}
              navigate={(tabName: TabName) => {
                const i = getTabIndex(tabName);
                if (i >= 0) {
                  setValue(i);
                }
              }}
              setNestedTabNameFlag={setNestedTabNameFlag}
              handleSaveAppFromOverview={handleSaveAppFromOverview}
            />
          }
        </TabPanel>
      }

      {primary && value === getTabIndex('Applicant') &&
        <ApplicantInfo
          appCustomer={primary}
          nestedTabNameFlag={nestedTabNameFlag}
          setNestedTabNameFlag={setNestedTabNameFlag}
        />
      }
      {cobuyer1 && value === getTabIndex('Co-Applicant 1') &&
        <ApplicantInfo
          appCustomer={cobuyer1}
          nestedTabNameFlag={nestedTabNameFlag}
          setNestedTabNameFlag={setNestedTabNameFlag}
        />
      }
      {cobuyer2 && value === getTabIndex('Co-Applicant 2') &&
        <ApplicantInfo
          appCustomer={cobuyer2}
          nestedTabNameFlag={nestedTabNameFlag}
          setNestedTabNameFlag={setNestedTabNameFlag}
        />
      }
      {!(configuration?.featureFlags?.[FeatureFlagIds.HideBureauTab] === true && (isInRole(Constants.roles.salespersonId, currentUser))) &&
        <TabPanel value={value} index={getTabIndex('Bureau')}>
          {value === getTabIndex('Bureau') &&
            <BureauPage
              workNumber={configuration?.featureFlags?.[FeatureFlagIds.WorkNumber]}
            />
          }
        </TabPanel>
      }
      {userCanViewVehicleTab &&
        <TabPanel value={value} index={getTabIndex('Vehicle')}>
          {value === getTabIndex('Vehicle') && <VehicleSelect />}
        </TabPanel>
      }
      {userCanViewCustomFieldsTab &&
        <TabPanel value={value} index={getTabIndex('Custom Fields')}>
          <CustomFieldForm
            showScoreColumn={true}
            onUpdateApplicationCustomField={handleCustomFieldUpdate}
            entityCustomFields={currentApp?.applicationCustomFields}
            lockedByPostStatus={isSectionLocked('CustomFields')}
            lockedMessage={lockMessage}
          />
        </TabPanel>
      }
      {userCanViewBudgetTab &&
        <TabPanel value={value} index={getTabIndex('Budget')} >
          {isSectionLocked('Budget') && <LockNotice message={lockMessage} />}
          {value === getTabIndex('Budget') && <BudgetPage app={currentApp} disabled={canNotEditBudget || isSectionLocked('Budget')} />}
        </TabPanel>
      }
      <TabPanel value={value} index={getTabIndex('Documents')}>
        {value === getTabIndex('Documents') && applicationDocumentsFromServer &&
          <ApplicationDocuments
            documents={applicationDocumentsFromServer || []}
            applicationId={currentApp.id}
            style={{
              ...tabItemStyle,
              paddingBottom: '50px'
            }}
          />
        }
      </TabPanel>
      {userCanViewStipsTab && //(currentApp?.quoteType === ApplicationQuoteType.Indirect) &&
        <TabPanel value={value} index={getTabIndex('Stips')} style={{ padding: 0 }}>
          {value === getTabIndex('Stips') &&
            <IndirectStipsEditor documents={applicationDocumentsFromServer || []} />
          }
        </TabPanel>
      }
      {userCanViewNotesTab && (
        <TabPanel value={value} index={getTabIndex('Notes')}>
          {value === getTabIndex('Notes') &&
            <ApplicationNotes
              style={tabItemStyle}
              notes={currentApp.applicationNotes?.filter(an => !an.deleted && an.applicationNoteRoles?.length === 0)}
              onAddNote={addNote} />
          }
        </TabPanel>
      )}
      {userCanViewUnderwriterNotesTab &&
        <TabPanel value={value} index={getTabIndex('Underwriter Notes')}>
          {value === getTabIndex('Underwriter Notes') &&
            <UnderwriterNotes
              style={tabItemStyle}
              notes={currentApp.applicationNotes?.filter(an => !an.deleted && an.applicationNoteRoles?.length && an.applicationNoteRoles?.length > 0)} onAddNote={addUnderwriterNote}
            />
          }
        </TabPanel>
      }
      {showFundingTab &&
        <TabPanel value={value} index={getTabIndex('Funding')}>
          {value === getTabIndex('Funding') &&
            <FundingPage
              // If showFundingTab is true then indirectQuote is defined
              underwriterQuote={underWriterQuote!.quote}
              configuration={configuration}
            />
          }
        </TabPanel>
      }
      {userCanViewJdPowersportHistory &&
        <TabPanel value={value} index={getTabIndex('JD Powersport History')}>
          {value === getTabIndex('JD Powersport History') &&
            <JdPowersportHistory />
          }
        </TabPanel>
      }
      {userCanViewNotificationsTab &&
        <TabPanel value={value} index={getTabIndex('Notifications')}>
          {value === getTabIndex('Notifications') &&
            <EmailNotifications />
          }
        </TabPanel>
      }


      {configuration?.featureFlags?.[FeatureFlagIds.OverrideBusinessRules] === true && (
        <TabPanel value={value} index={getTabIndex('Validation Rules')}>
          <RuleOverrideEditor
            canOverride={currentApp?.appStatusId?.toLowerCase() !== Constants.applicationStatuses.approved.toLowerCase() && currentApp?.appStatusId?.toLowerCase() !== Constants.applicationStatuses.conditionallyApproved.toLowerCase() && currentApp?.appStatusId?.toLowerCase() !== Constants.applicationStatuses.finalizedPosted.toLowerCase()}
            businessRuleOverrideItems={currentApp?.businessRuleOverrides ?? []}
            businessRuleOverrideStatuses={lookups.businessRuleOverrideStatuses}
            onOverrideItem={(businessRuleOverrideId: string, overrideStatusId: string, comments: string) => {
              // update app and dispatch updateEditingApp action
              const updatedApp = produce(currentApp!, appToUpdate => {
                const businessRuleOverride = appToUpdate.businessRuleOverrides?.find(bro => bro.id === businessRuleOverrideId);
                if (businessRuleOverride) {
                  businessRuleOverride.businessRuleOverrideStatusId = overrideStatusId;
                  businessRuleOverride.reason = comments;
                  businessRuleOverride.modifiedBy = `${currentUser?.firstName} ${currentUser?.lastName}`;
                  businessRuleOverride.modifiedDate = new Date();
                }
              })
              dispatch(updateEditingApp(updatedApp, businessRulesEngine));
            }}
            onUnwaiveItem={(businessRuleOverrideId: string) => {
              // update app and dispatch updateEditingApp action
              const updatedApp = produce(currentApp!, appToUpdate => {
                const businessRuleOverride = appToUpdate.businessRuleOverrides?.find(bro => bro.id === businessRuleOverrideId);
                if (businessRuleOverride) {
                  // Unwaive the business rule by setting the status to null. The rules will re-run, and the status will be updated accordingly.
                  businessRuleOverride.businessRuleOverrideStatusId = null;
                  // Remove comment from the business rule override because we are unwaiving it.
                  businessRuleOverride.reason = undefined;
                }
              })
              dispatch(updateEditingApp(updatedApp, businessRulesEngine));
            }}
          />
        </TabPanel>
      )}
      {userCanViewIncomeVerificationTab &&
        <TabPanel value={value} index={getTabIndex('Income Verification')}>
          {value === getTabIndex('Income Verification') && // applicationFinicityDocumentsFromServer != null && applicationFinicityDocumentsFromServer.length > 0 &&
            <IncomeVerificationPage
              documents={applicationFinicityDocumentsFromServer || []}
              applicationId={currentApp.id}
              style={{
                ...tabItemStyle,
                paddingBottom: '50px'
              }}
            />
          }
        </TabPanel>
      }
      {!hideChatBar(configuration?.clientId) &&
        <>
          <TextMessageChat
            applicationId={currentApp?.id}
            rightSideBarWidth={rightSideBarWidth}
          />
          <div style={{ position: 'static', width: '100%', height: 50 }}></div>
        </>
      }
      {
        showNotesPopup &&
        <NotesDialog
          notes={currentApp?.applicationNotes ?? []}
          employee={currentUser as IEmployee}
          canAddNote={true}
          open={showNotesPopup}
          onSave={handleAddNotes}
          mode='single'
          onClose={() => {
            setShowNotesPopup(false);
          }}
        />
      }
      <NotePopup
        open={showUnderwriterNotesPopup}
        addNote={(note: string) => {
          // Add new note to this application.
          const newNote = {
            id: v4(),
            applicationId: currentApp.id,
            employeeId: currentUser!.id,
            employee: currentUser,
            note: note,
            deleted: false,
            createdDate: new Date(),
            modifiedDate: null,
            applicationNoteRoles: [Constants.roles.underwriterId],
          };
          addApplicationUnderwriterNotes(currentApp!.id, currentUser!.id, [newNote], dispatch);
          // Close the popup.
          setShowUnderwriterNotesPopup(false);
        }}
        onClose={() => setShowUnderwriterNotesPopup(false)}
      />
      {
        currentApp &&
        currentApp.applicationChecklists &&
        canViewAnyAvailableChecklist(currentUser!, currentApp.applicationChecklists.map(ac => ac.checklistId), lookups.employeeRoleChecklists) &&
        <Tooltip
          title={(
            <ChecklistButtonToolTipText
              applicationChecklists={currentApp.applicationChecklists}
              lookups={lookups}
            />
          )}
          placement={"left"}
          arrow={true}
          style={{
            position: "fixed",
            top: "72px",
            right: isChecklistOpen ? `${(rightSideBarWidth ?? defaultRightSideBarWidth) + 25}px` : "10px",
            zIndex: 1202,
            backgroundColor: isHoveringOverCheck ? 'Gainsboro' : undefined
          }}
        >
          <IconButton
            onMouseEnter={() => { setIsHoveringOverCheck(true) }}
            onMouseLeave={() => { setIsHoveringOverCheck(false) }}
            size={"small"}
            onClick={() => {
              if (isChecklistOpen) {
                setRightSideBarWidth(0);
                closeDrawer();
                setIsChecklistOpen(false)
              } else {
                setRightSideBarWidth(defaultRightSideBarWidth);
                setIsChecklistOpen(true);
                openDrawer({
                  className: styles.checklist,
                  children: (
                    <ApplicationChecklistSideBar
                      sideBarWidth={defaultRightSideBarWidth}
                    />
                  ),
                  variant: "persistent",
                  anchor: "right",
                });
              }
            }}
          >
            <CheckIcon
              color={allApplicationChecklistsAreComplete(lookups.checklists, currentApp.applicationChecklists)
                ? 'primary'
                : 'error'}
            />
          </IconButton>
        </Tooltip>
      }
    </div >
  );
};
export default OrderEditorTabs;
export type TabName =
  | "Overview"
  | "Applicant"
  | "Co-Applicant 1"
  | "Co-Applicant 2"
  | "Bureau"
  | "Vehicle"
  | "Custom Fields"
  | "Budget"
  | "Documents"
  | "Stips"
  | "Notes"
  | "Funding"
  | "Audit Log"
  | "JD Powersport History"
  | "Underwriter Notes"
  | "Notifications"
  | "Evaluation"
  | "Income Verification"
  | "Validation Rules";

const tabNameToAction: { [key in TabName]: BusinessAction } = {
  Overview: "View Overview",
  Applicant: "View Applicant",
  "Co-Applicant 1": "View Co-Applicant 1",
  "Co-Applicant 2": "View Co-Applicant 2",
  Bureau: "View Bureau",
  Vehicle: "View Vehicle",
  "Custom Fields": "View Custom Fields",
  Budget: "View Budget",
  Documents: "View Documents",
  Stips: "View Stipulation(s)",
  Notes: "View Notes",
  Funding: "View Funding",
  "Audit Log": "View Audit Log",
  "JD Powersport History": "View JD Powersport History",
  "Underwriter Notes": "View Underwriter Notes",
  Notifications: "View Notifications",
  Evaluation: "View Evaluation",
  "Income Verification": "View Income Verification",
  "Validation Rules": "View Validation Rules",
};
